import React from "react";
import { Box, Dialog, Slide, Stack, SwipeableDrawer, Typography } from "@mui/material"
import AdditionalFilters from "./AdditionalFilters"
import DialogBox from "../../../../core-components/theme/components/DialogBox/DialogBox"
import { FMFMobileFilterDialogInterface } from "../../types"

import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FMFMobileFilterDialog = ({handleClose, ...props}: FMFMobileFilterDialogInterface) => {
  return (
    // <DialogBox width="100%" height="100%" open={true} handleClose={handleClose} title="" dialogStyles={{paddingLeft: '18px', margin: '0'}}>
    // <Dialog
    //     fullScreen
    //     open={true}
    //     onClose={handleClose}
    //     slots={{
    //       transition: Transition,
    //     }}
    //     sx={{
    //       '& .MuiDialog-paper': {
    //         width: '100%',
    //         maxWidth: '100%',
    //         margin: '0',
    //         padding: 0,
    //         gap: 3,
    //       },
    //     }}
    //   >
         <SwipeableDrawer
            anchor={'bottom'}
            open={true}
            onOpen={handleClose}
            onClose={handleClose}
            sx={{
              '& .MuiDrawer-paper': {
                width: '100%',
                maxWidth: '100%',
                margin: '0',
                padding: 0,
                // height: '50%',
                background: 'rgba(255, 255, 255, 0.95)',
                boxShadow: 'none'
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                }
              }
            }}
          >
            <Box sx={{ px: 3, py: 4, height: "100%", backgroundColor: 'rgba(255, 255, 255, 0.95)', }}>
              <Stack spacing={5}>
                {/* <Typography variant="title">Add Filters</Typography> */}
                <AdditionalFilters {...props}/>
              </Stack>
            </Box>
          </SwipeableDrawer>
  )
}

export default FMFMobileFilterDialog;